export default __webpack_public_path__ + "static/media/schedule-session.47fb0de9.svg";